import React from 'react';
import Icon from '../../app_components/Icon';
import StandardButton from '../../app_components/StandardButton';
import { semantic } from '@lexody/design-tokens';
import { isMissingAvatar } from '../../connect_sections/connectMemberHelpers';
import { usesDashFormVariant } from '../../../utils/formVariant';

class ProfilePictureSection extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      avatar_url: '',
      loading: false,
      avatarImageFailed: false,
      uploadError: null,
    };
    this.onFileChange = this.onFileChange.bind(this);
    this.uploadImage = this.uploadImage.bind(this);
    this.handleAvatarImageError = this.handleAvatarImageError.bind(this);
    this.handleAvatarImageLoad = this.handleAvatarImageLoad.bind(this);
    this.fileInput = React.createRef();
    this.renderImage = this.renderImage.bind(this);
  }

  componentDidMount() {
    this.syncAvatarFromProps();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.user.avatar_url !== this.props.user.avatar_url) {
      this.syncAvatarFromProps();
    }
  }

  syncAvatarFromProps() {
    this.setState({
      avatar_url: this.props.user.avatar_url,
      avatarImageFailed: false,
      uploadError: null,
    });
  }

  parseUploadError(xhr) {
    try {
      const body = (xhr && xhr.responseJSON) || JSON.parse((xhr && xhr.responseText) || '{}');
      return body.error || 'Upload failed. Please try again.';
    } catch (e) {
      return 'Upload failed. Please try again.';
    }
  }

  uploadImage(image) {
    this.setState({ loading: true, uploadError: null, avatarImageFailed: false });
    const formData = new FormData();
    const ext = (image.name && image.name.split('.').pop()) || 'png';
    const filename = `${this.props.user.first_name}_${this.props.user.last_name}.${ext}`;
    formData.append('avatar', image, filename);
    $.ajax({
      url: '../update_user_avatar',
      dataType: 'JSON',
      type: 'POST',
      header: {
        'Content-Type': 'application/json',
      },
      processData: false,
      contentType: false,
      data: formData,
      success: (data) => {
        const avatarUrl = data.data.avatar_url;
        this.setState({
          avatar_url: avatarUrl,
          loading: false,
          avatarImageFailed: false,
          uploadError: null,
        });
        if (this.props.onAvatarUploaded) {
          this.props.onAvatarUploaded(avatarUrl);
        }
      },
      error: (xhr, status, err) => {
        console.log(err);
        this.setState({
          loading: false,
          uploadError: this.parseUploadError(xhr),
        });
        if (this.props.onUploadError) {
          this.props.onUploadError(this.parseUploadError(xhr));
        }
      },
    });
  }

  handleAvatarImageLoad() {
    if (this.props.onAvatarConfirmed) {
      this.props.onAvatarConfirmed(this.state.avatar_url);
    }
  }

  handleAvatarImageError() {
    this.setState({ avatarImageFailed: true });
    if (this.props.onAvatarBroken) {
      this.props.onAvatarBroken();
    }
  }

  onFileChange(event) {
    const image = event.target.files[0];
    if (image) {
      this.uploadImage(image);
    }
  }

  triggerInputFile = () => {
    if (this.fileInput.current != undefined && this.fileInput.current.click != undefined) {
      this.fileInput.current.click();
    }
  };

  renderImage() {
    if (this.state.loading) {
      return (
        <div className="lex-avatar-upload__placeholder">
          <Icon name="spinner" size={28} color={semantic.premium.text.label} />
          <span>Uploading…</span>
        </div>
      );
    }

    if (!isMissingAvatar(this.state.avatar_url) && !this.state.avatarImageFailed) {
      return (
        <img
          src={this.state.avatar_url}
          alt="Profile"
          onLoad={this.handleAvatarImageLoad}
          onError={this.handleAvatarImageError}
        />
      );
    }

    return (
      <div className="lex-avatar-upload__placeholder">
        <Icon name="image" size={32} color={semantic.premium.text.label} />
        <span>Show us your smile!</span>
      </div>
    );
  }

  render() {
    const hasPhoto = !isMissingAvatar(this.state.avatar_url) && !this.state.avatarImageFailed;
    const isDash = usesDashFormVariant(this.props.variant);

    return (
      <div className="lex-avatar-upload">
        <div
          className="lex-avatar-upload__frame"
          onClick={() => this.triggerInputFile()}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              this.triggerInputFile();
            }
          }}
        >
          {this.renderImage()}
          {isDash && (
            <span className="lex-avatar-upload__cameraBadge" aria-hidden="true">
              <Icon name="image" size={14} color="#fff" solid />
            </span>
          )}
        </div>
        {!isDash && (
          <StandardButton
            text={hasPhoto ? 'Change photo' : 'Add photo'}
            variant="secondary"
            onClick={() => this.triggerInputFile()}
          />
        )}
        {this.state.uploadError && (
          <p className="lex-avatar-upload__error" role="alert">{this.state.uploadError}</p>
        )}
        <input ref={this.fileInput} type="file" hidden onChange={this.onFileChange} accept="image/*" />
      </div>
    );
  }
}

export default ProfilePictureSection;
